import React, { Component, Fragment } from 'react';
import { Button, Checkbox, Modal } from 'antd';
import { includes } from 'lodash';

class Splash extends Component {
  constructor(props) {
    super(props);
    this.state = {
      splashFrame: null,
    };
  }

  onChange = (e) => {
    localStorage.setItem('splash', false);
    console.log(e.target.checked);
  };

  render() {
    const currentHash = window.location.search.replace('#', '').split('&');

    return (
      <Fragment>
        {true && (
          <Modal
            className="splash-modal"
            title={
              this.props.translations
                ? this.props.translations.splashTitle
                : 'splash'
            }
            visible={this.props.visible}
            onOk={this.props.onOk}
            onCancel={this.props.onOk}
            width={1280}
            footer={
              <div>
                {this.props.showCheckbox && (
                  <Checkbox id="splash-checkbox" onChange={this.onChange}>
                    Do not show again
                  </Checkbox>
                )}
                <Button
                  id="splash-ok"
                  key="submit"
                  type="primary"
                  onClick={this.props.onOk}
                >
                  OK
                </Button>
              </div>
            }
          >
            {this.props.url && (
              <iframe id="splash" title="splash" src={this.props.url} />
            )}
          </Modal>
        )}
      </Fragment>
    );
  }
}

export default Splash;



// WEBPACK FOOTER //
// ./src/components/Splash.js